import React from "react";
import s from './LoaderImg.module.scss'

const LoaderImg = ({color}) => {
  return <span className={`${s.loader} ${color? s[color] : s.gray}`}></span>
}

export default LoaderImg